import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { sendDynamicAnswers, setCurrentStep } from "../../onboardingSlice";
import { getImage } from "../../../../utilities/iconResolver";
import { t } from "../../../../utilities/translator";
import { setUser } from "../../../user/userSlice";
import useUserPreferences from "../../../../hooks/preferences/useUserPreferences";

const DynamicStepsSuccess = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.user);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { updatePreference } = useUserPreferences(user?.muid || '')

  useEffect(() => {
    const sendAnswers = async () => {
      try {
        const result = await dispatch(sendDynamicAnswers()).unwrap();
        const data = await result.json();
        if (data.hf_user) {
          dispatch(setUser(data.hf_user));
          localStorage.setItem('hf_user', JSON.stringify(data.hf_user));
          updateAutomaticallySelectedFilters(data.hf_user)
        }
      } catch(error) {
        console.log(error);
      }
    }

    sendAnswers()

    timeoutRef.current = setTimeout(() => dispatch(setCurrentStep(1)), 2000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
  }, [dispatch])

  const updateAutomaticallySelectedFilters = (user) => {
    if (user?.preferences?.general) {
      const generalPreferences = user.preferences.general;
      updatePreference({ breakfast_quality: !!generalPreferences?.breakfast_quality });
    }
  }

  return (
    <div>
      <div className="wizard-step pb-10 gap-10 h-full justify-center">
        <div className="flex flex-wrap gap-2 justify-center relative">
          <img src={getImage('feed-builder-animation.gif')} alt="123" />
          <div className="text-center dynamic-step-success flex flex-col items-center gap-3">
            <span>🎉</span>
            <div className="text-xl font-semibold">{t('onboarding.questionsFinished')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DynamicStepsSuccess
